/**
 * Sessions Index Route
 * Session management and history page (List View)
 * Path: /sessions/
 */

import { createFileRoute } from '@tanstack/react-router';
import { SessionsPage } from '../../pages/Sessions/SessionsPage';

const SessionsIndexRouteComponent = () => {
  return <SessionsPage />;
};

export const Route = createFileRoute('/_authenticated/sessions/')({
  component: SessionsIndexRouteComponent,
});
